// extracted by mini-css-extract-plugin
export default {"animateGradientSlide":"loadingBar_animateGradientSlide__uu7Bd","gradient-slide":"loadingBar_gradient-slide__AyPAx"};